import PersistentStore from "@/api/PersistentStore";
import { RootState } from "@/store/types";
import { Module } from "vuex";
import { actions } from "./actions";
import { getters } from "./getters";
import { mutations } from "./mutations";
import { DisplayMode, NavigationState } from "./types";

export const DARK_MODE_KEY = "darkMode";

export const STATIC_TITLE_KEY = "staticTitle";
export const CENSUS_PREFERENCE_KEY = "censusPreferences";

const darkModeStatus: DisplayMode = PersistentStore.getItem(DARK_MODE_KEY, {
  mode: "unset",
  os: "unset"
});

export const state: NavigationState = {
  currentId: "",
  display: { theme: darkModeStatus, showLegendMobile: false },
  inWrapper: false,
  mobilePage: 1,
  helpStep: 0,
  redirectTo: null,
  openWindows: [],
  censusPreferences: PersistentStore.getItem(CENSUS_PREFERENCE_KEY, {}),
  routeHistory: [],
  staticTitle: PersistentStore.getItem(STATIC_TITLE_KEY, false)
};

export const navigationNamespace = { namespace: "navigation" };

const namespaced: boolean = true;

export const navigation: Module<NavigationState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
